import { Component, OnInit } from '@angular/core';
import { NbDialogRef, NbDialogService, NbGlobalPhysicalPosition, NbToastrService } from '@nebular/theme';
import { ProfileService } from 'src/app/services/profile.service';
import { EditInterestsComponent } from '../edit-interests/edit-interests.component';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss']
})
export class EditProfileComponent implements OnInit {
  customStyle = {
   backgroundColor: "#ffffff",
   border: "1px solid #7e7e7e",
   borderRadius: "50%",
   color: "#7e7e7e",
   cursor: "pointer"
 };
 show: boolean = false;
 dataInvest: any[] = [];
 dataOptions: any[] = [];
 dataList: any[] = [];
 companyName: string = '';
 companyTitle: string = '';
 user: any;
 fullName: string;
 disabled: boolean = false;
 text: string = '';

 constructor(protected ref: NbDialogRef<EditProfileComponent>, private dialogService: NbDialogService,  private profile: ProfileService, private toastrService: NbToastrService) {}

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.fullName = this.user.firstName + ' ' + this.user.lastName;
    this.profile.getIntroduction(this.user.id).subscribe(res => {
      // console.log(res)
      if(res) {
        this.text = res[0].introduction;
      }
    })
  }

  close () {
    this.ref.close();
  }

  submit() {
    this.ref.close();
  }

  editIntroduction() {
    this.disabled = true;
    this.dialogService.open(EditInterestsComponent, {dialogClass: 'model4-full', hasBackdrop: true, closeOnBackdropClick : false, autoFocus: true})
    .onClose.subscribe(res => {
      this.disabled = false;
      // console.log(res);
      if(res) {
        const body = {introduction: res};
        this.profile.postIntroduction(body).subscribe(res => {
          if(res) {
            this.profile.getIntroduction(this.user.id).subscribe(res => {
              if(res) {
                this.text = res[0].introduction;
                this.toastrService.show(
                  'Success',
                  'Successfull Form submission',
                  { position : NbGlobalPhysicalPosition.BOTTOM_LEFT, status: 'success', duration: 2000 });
              }
            });
          }
        },
        error => {
          this.toastrService.show(
            'Error',
            'Unsuccessfull Form submission',
            { position : NbGlobalPhysicalPosition.BOTTOM_LEFT, status: 'danger', duration: 2000 });
        })
      }
    });
  }
}
